<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>

        </div>

       <div class="content" v-else>

               <h1 v-if="type === 'add'">
                    Vytváření autora
               </h1>
               <h1 v-else>
                    Detail autora
               </h1>


           <v-layout>
               <table class="info-table">
                   <tr>
                       <td class="info-table__title">
                           Náhledový obrázek:
                       </td>
                       <td class="info-table__value">


                           <div v-if="!imageUploaded">
                               <div class="image image--loader">
                                   <div class="loader">
                                       <div class="loader__item">
                                       </div>
                                       <div class="loader__text">Nahrávání</div>
                                   </div>
                               </div>
                           </div>
                           <div v-else>
                               <div class="image image--data" v-if="data.image" :style="'background-image:url('+data.image+')'">
                               </div>
                               <div class="image image--empty" v-else>
                               </div>
                           </div>



                           <div class="image-controls"  v-if="imageUploaded ">
                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="!data.image"
                                       color="primary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat
                               </v-btn>

                               <v-btn
                                       @click="selectCoverImage()"
                                       v-if="data.image"
                                       color="secondary"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Vybrat jiný
                               </v-btn>
                               <v-btn
                                       @click="removeCoverImage()"
                                       v-if="data.image"
                                       color="error"
                                       type="submit"
                                       class="button--inputs"
                               >
                                   Smazat
                               </v-btn>
                           </div>
                       </td>
                   </tr>
	               <tr >
		               <td class="info-table__title">
			               Alt:
		               </td>
		               <td class="info-table__value">
			               <v-text-field

				                class="input--larger"
				                outlined
				                @input="errors.image_alt = ''"
				                v-model="data.image_alt"
				                :error-messages="makeError(errors.image_alt)"
			               >
			               </v-text-field>
		               </td>
	               </tr>
                   <tr v-if="type !== 'add'">
                       <td class="info-table__title">
                           ID:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   disabled
                                   class="input--small"
                                   outlined
                                   @input="errors.id = ''"
                                   v-model="data.id"
                                   :error-messages="makeError(errors.id)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Jméno: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.forename = ''"
                                   v-model="data.forename"
                                   :error-messages="makeError(errors.forename)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Příjmení: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.surname = ''"
                                   v-model="data.surname"
                                   :error-messages="makeError(errors.surname)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Slug: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.slug = ''"
                                   v-model="data.slug"
                                   :error-messages="makeError(errors.slug)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis: <span class="required-symbol">*</span>
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   @input="errors.description = ''"
                                   v-model="data.description"
                                   :error-messages="makeError(errors.description)"
                           >
                           </v-textarea>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Publikováno:
                       </td>
                       <td class="info-table__value">
                           <v-checkbox
                                   class="input--small"
                                   outlined
                                   @input="errors.published = ''"
                                   v-model="data.published"
                                   :error-messages="makeError(errors.published)"
                           >
                           </v-checkbox>
                       </td>
                   </tr>
               </table>

           </v-layout>

           <h2>SEO</h2>
           <v-layout>

               <table class="info-table">

                   <tr>
                       <td class="info-table__title">
                           Titulek:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input--small"
                                   outlined
                                   @input="errors.seo_title = ''"
                                   v-model="data.seo_title"
                                   :error-messages="makeError(errors.seo_title)"
                           >
                           </v-text-field>
                       </td>
                   </tr>
                   <tr>
                       <td class="info-table__title">
                           Popis:
                       </td>
                       <td class="info-table__value">
                           <v-textarea
                                   class="input--larger"
                                   outlined
                                   @input="errors.seo_meta = ''"
                                   v-model="data.seo_meta"
                                   :error-messages="makeError(errors.seo_meta)"
                           >
                           </v-textarea>
                       </td>
                   </tr>
                   <!--<tr>
                       <td class="info-table__title">
                           Klíčová slova:
                       </td>
                       <td class="info-table__value">
                           <v-text-field
                                   class="input&#45;&#45;larger"
                                   outlined
                                   @input="errors.seo_keywords = ''"
                                   v-model="data.seo_keywords"
                                   :error-messages="makeError(errors.seo_keywords)"
                           >
                           </v-text-field>
                       </td>
                   </tr>-->
               </table>
           </v-layout>
           <v-layout>
               <div class="controls-table">
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="addAuthor()"
                           v-if="type === 'add'
                    ">
                       Vytvořit
                   </v-btn>
                   <v-btn
                           color="primary"
                           type="submit"
                           class="button--control"
                           @click="editAuthor()"
                           v-else
                    >
                       Uložit
                   </v-btn>
                   <v-btn
                           color="error"
                           class="button--control"
                           @click="openDialogDelete()"
                           v-if="type !== 'add'"
                   >
                       Smazat
                   </v-btn>
               </div>
           </v-layout>

           <v-dialog v-model="dialogDelete" persistent>
               <v-card>
                   <v-card-title class="headline">Smazání autora</v-card-title>
                   <v-card-text>
                       Opravdu si přejete smazat autora <strong>{{data.name}}</strong>?
                   </v-card-text>
                   <v-card-actions>
                       <v-spacer></v-spacer>
                       <v-btn
                               color="empty"
                               class="button--dialog"
                               @click="closeDialogDelete()"
                       >
                           zrušit
                       </v-btn>
                       <v-btn
                               color="error"
                               class="button--dialog"
                               @click="deleteAuthor()"
                       >
                           smazat
                       </v-btn>
                       <v-spacer></v-spacer>
                   </v-card-actions>
               </v-card>
           </v-dialog>
       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    export default {
        name: 'AuthorsDetail',
        components: {
        },

        data() {
            return {
                imageUploaded: true,
                dialogDelete:false,
                type: 'add',
                loaded: false,
                data: {},
                errors: {}

            }
        },

        created() {

            const vm = this;
            this.$root.$on('upload-author-image', () => {
                vm.imageUploaded = false;
                vm.$forceUpdate();
            });

            this.$root.$on('uploaded-author-image', (response) => {
                vm.data.image = response.url;
                vm.data.image_id = response.id;
                vm.imageUploaded = true;
                vm.$forceUpdate();
            });
            this.fetchData();


        },
        computed: {
            ...mapState(['profile']),

        },
        mounted(){
        },
        methods: {
            selectCoverImage(){
                this.$root.$emit('select-author-image');
            },
            removeCoverImage(){
                this.data.image_id = null;
                this.data.image = null;
                this.$forceUpdate();
            },
            makeError(item){
                if(item === 'required'){
                    return 'Toto pole je povinné';
                }else if(item === 'already_used'){
                    return 'Je již používaný';
                }else if(item === 'not_valid'){
                    return 'Neplatný formát';
                }else if(item){
                    return 'Neznámá chyba';
                }else{
                    return '';
                }

            },
            openDialogDelete(){
                this.dialogDelete = true;
            },
            closeDialogDelete(){
                this.dialogDelete = false;
            },

            addAuthor(){
                this.loaded = false;
                const request = this.data;
                this.$axios.post('/admin/authors/add', request).then((response) => {
                    this.$router.push({name: 'Authors'});
                }).catch((e) => {
                    if(e.response.data.error_inputs){
                        this.errors = e.response.data.error_inputs
                    }
                    this.loaded = true;
                });
            },
            editAuthor(){
                this.loaded = false;
                const request = this.data;
                this.$axios.put('/admin/authors/'+this.$route.params.id+'/edit', request).then((response) => {
                    this.$router.push({name: 'Authors'});
                }).catch((e) => {
                    this.errors = e.response.data.error_inputs;
                    this.loaded = true;
                });
            },
            deleteAuthor(){
                this.loaded = false;
                const request = this.data;
                this.$axios.delete('/admin/authors/'+this.$route.params.id+'/delete', request).then((response) => {
                    this.$router.push({name: 'Authors'});
                }).catch((e) => {
                    this.loaded = true;
                });
            },
            fetchData(){

                if(this.$route.params.id === 'add'){
                    this.type = 'add';
                    this.data = {};
                    this.loaded = true;

                }else{
                    this.type = 'detail';
                    this.$axios.get('/admin/authors/' + this.$route.params.id).then((response) => {
                        this.type = 'detail';
                        this.data = response.data.author;
                        this.loaded = true;
                    }).catch((e) => {
                        this.$router.push({name: 'Authors'});
                        this.loaded = true;
                    });
                }
            },



        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
